import { useLang } from "../../i18n/LanguageContext";
import { useInView } from "../../hooks/useInteractions";
import Reveal from "../shared/Reveal";

export const Process = () => {
  const { t } = useLang();
  const [lineRef, lineIn] = useInView(0.3);

  return (
    <section className="relative py-20 md:py-32" data-testid="process-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 md:px-8">
        <Reveal variant="fade-up" className="max-w-2xl mb-14">
          <div className="text-xs mono-label text-cyan-400 mb-3">{t.process.eyebrow}</div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-semibold tracking-tight text-strong">
            {t.process.title}
          </h2>
        </Reveal>

        <div className="relative" ref={lineRef}>
          {/* Animated connecting line */}
          <svg
            className="hidden lg:block absolute top-14 left-0 w-full h-px pointer-events-none overflow-visible"
            aria-hidden
          >
            <line
              x1="6%"
              y1="0"
              x2="94%"
              y2="0"
              stroke="rgba(0,229,255,0.5)"
              strokeWidth="1.5"
              strokeDasharray="6 4"
              strokeDashoffset={lineIn ? 0 : 1000}
              style={{
                transition: "stroke-dashoffset 2.2s cubic-bezier(0.6,0.05,0.2,1)",
              }}
            />
          </svg>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {t.process.steps.map((s, i) => (
              <div
                key={i}
                data-testid={`process-step-${i}`}
                className="relative glass rounded-2xl p-6 hover-lift group hover:border-cyan-400/40 transition-all"
                style={{
                  animation: lineIn ? `fade-up 0.7s ease-out ${i * 180}ms forwards` : "none",
                  opacity: lineIn ? undefined : 0,
                }}
              >
                <div className="flex items-start justify-between mb-8">
                  <div className="text-5xl font-bold gradient-text tracking-tight">{s.label}</div>
                  <div className="relative">
                    {/* Outer pulsing ring */}
                    <div className="absolute -inset-2 rounded-full border border-cyan-400/30 opacity-0 group-hover:opacity-100 animate-pulse-glow" />
                    <div className="w-3 h-3 rounded-full bg-cyan-400 shadow-[0_0_16px_rgba(0,229,255,0.7)] group-hover:scale-125 transition" />
                  </div>
                </div>
                <h3 className="text-xl font-semibold text-strong mb-2">{s.name}</h3>
                <p className="text-mid text-sm leading-relaxed">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
